import { application } from "./application";

import AllmedsController from "./allmeds_controller";
import CatalogTabsController from "./catalog_tabs_controller";
import MeditationCardController from "./meditation_card_controller";
import PlayerController from "./player_controller";
import PacksController from "./packs_controller";
import TotopController from "./totop_controller";
import WaveformController from "./waveform_controller";
import CheckoutController from "./checkout_controller";
import ConsentController from "./consent_controller";
import LocaleHintController from "./locale_hint_controller";
import LocaleSwitchController from "./locale_switch_controller";
application.register("allmeds", AllmedsController);
application.register("catalog-tabs", CatalogTabsController);
application.register("meditation-card", MeditationCardController);
application.register("player", PlayerController);
application.register("packs", PacksController);
application.register("totop", TotopController);
application.register("waveform", WaveformController);
application.register("checkout", CheckoutController);
application.register("consent", ConsentController);
application.register("locale-hint", LocaleHintController);
application.register("locale-switch", LocaleSwitchController);
